import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import styled from 'styled-components';

const StyledStatRow = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem;

  ul {
    display: flex;
    justify-content: center;
    gap: 3rem;
    flex-wrap: wrap;
    padding: 0;
  }

  li {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .stat {
    color: var(--primary);
  }
`;

const StatRow = ({ heading, stats }) => {
  return (
    <StyledStatRow>
      {heading && <h3 className="heading-xl-ultralight">{heading}</h3>}
      <ul>
        {stats.map((stat, idx) => {
          return (
            <li key={idx}>
              <div className="stat heading-4xl-semibold">{stat.stat}</div>
              <div className="metric">
                {typeof stat.metric === 'string' ? (
                  <p className="heading-l-light">{stat.metric}</p>
                ) : (
                  <PrismicRichText
                    field={stat.metric.richText}
                    components={{
                      paragraph: ({ children }) => <p className="heading-l-light">{children}</p>,
                    }}
                  />
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </StyledStatRow>
  );
};
export default StatRow;
